import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { globalVar } from 'src/app/shared/global_variables';
import { environment } from 'src/environments/environment';
import { GetAppContext } from './GetAppContext';

const USERADMIN = '/useradmin';
const SESSION = '/session';
const GET_APP_CONTEXT = USERADMIN + '/getAppContext';
const RESET_APP_CONTEXT = SESSION + '/resetAppContext';
const GET_OAUTH_PROPERTIES = '/oauth/getOauthProperties';
const INVALIDATE_SESSION = '/session/invalidate';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private httpClient: HttpClient) {}

    public invalidateSession(): Observable<{}> {
        return this.httpClient.get(environment.baseUrl + globalVar.requestPrefix + INVALIDATE_SESSION);
    }

    public loadOAuthProperties(): Observable<OAuthProperties> {
        return this.httpClient.get<OAuthProperties>(environment.baseUrl + globalVar.requestPrefix + GET_OAUTH_PROPERTIES, { headers: { skip: 'true' } });
    }

    public getAppContext(): Observable<GetAppContext> {
        return this.httpClient.get<GetAppContext>(environment.baseUrl + globalVar.requestPrefix + GET_APP_CONTEXT, {
            headers: { AngularRequest: 'true' }
        });
    }
}

export type OAuthProperties = {
    clientId: string;
    url: string;
    redirectUrl: string;
    endSessionPath: string;
    authorizePath: string;
};
